/**
 * Dynamic Configuration Helper
 * 
 * Inspects client location at runtime to rewrite local network endpoints.
 */

export const getBackendUrl = () => {
    // Academy is a client of the main Stenope backend.  Override this only
    // when that shared backend is intentionally hosted elsewhere.
    const envUrl = process.env.REACT_APP_BACKEND_URL || 'http://localhost:8000';
    
    // In browser environments, replace localhost/127.0.0.1 with the actual hostname of the website
    if (typeof window !== 'undefined' && window.location) {
        const currentHost = window.location.hostname;
        if (currentHost && currentHost !== 'localhost' && currentHost !== '127.0.0.1') {
            return envUrl.replace('localhost', currentHost).replace('127.0.0.1', currentHost);
        }
    }
    return envUrl;
};

export const getApiUrl = () => {
    return `${getBackendUrl()}/api`;
};
